export interface PhoneAppCardState {
    errorState: PhoneAppCardErrorState;
}

export enum PhoneAppCardErrorState {
    Init = 0,
    Success = 1,
    Failure = 2,
}
